module.exports = "/_next/static/images/fb_footer-15c40b631a20ff4bf2947f59ef1532d4.png";